/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const CREATE_ASSORTMENT_RANGE = gql`
    mutation CreateEntityRange(
        $data: CreateEntityRangeInput!
        $serializationGroupId: ID!
        $gtinId: ID!
        $productBatchId: ID!
    ) {
        createEntityRange(
            data: $data
            serializationGroupId: $serializationGroupId
            gtinId: $gtinId
            productBatchId: $productBatchId
        ) {
            _id
            lowerBound
            upperBound
            serializationGroup
            batch
            variant
            item
        }
    }
`;
